module.exports = __webpack_public_path__ + "img/59.c7ac5f7b.jpg";